import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { FC, ReactNode, useCallback, useState } from 'react';

import {
  accordionSx,
  expandIconSx,
} from '../WorkcellFormModal/styles/workcellFormStyles';

interface ModalAccordionProps {
  children: ReactNode;
  title: ReactNode;
}

export const ModalAccordion: FC<ModalAccordionProps> = ({
  children,
  title,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = useCallback(() => setExpanded((prev) => !prev), []);

  return (
    <Accordion expanded={expanded} sx={accordionSx} onChange={handleChange}>
      <AccordionSummary sx={{ padding: 0 }}>
        <Typography variant="h6" sx={{ width: '100%' }}>
          {title}
        </Typography>
        <ExpandMoreIcon sx={expandIconSx(expanded)} />
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
